// extracted by mini-css-extract-plugin
module.exports = {"Poster":"Poster_Poster__AvyrC","Poster__image":"Poster_Poster__image__oHGNL"};